import type { FaireProductEntity } from "../../entity_types/product";

export const p_nnk56j8jt5: FaireProductEntity = {
  token: "p_nnk56j8jt5",
  type: "product",
  name: "Tinted Mineral Sunscreen Bundle (12) + Engraved Display",
  brandToken: "b_f2ec5373",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/e56a0ab802364997505ea4e05749d843ebd98ebbbca767771fcb053f42486f12.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/83e4fd8557a61a63d70bc6ddd65997acfe0d7619c2bb7677434d7b29cb96187d.png",
    "https://cdn.faire.com/fastly/612c9dc8cfd38e8639874029254170147e1165cf5a9927ad535e47d183d1484f.png",
    "https://cdn.faire.com/fastly/11415db3f3b7aaea968bafb9c914ffc323eaf964dd98df7302128f1cabb6a779.jpeg",
  ],
  priceDollars: 149.66,
  description:
    "NEW LOOK! ****2OZ PAPER PUSH UP TUBES HAVE SWITCHED TO 2OZ PLASTIC TWIST UP TUBES****\nTired of the only SAFE sunscreen being ones that turn you white? Introducing our NEW Tinted Mineral Foundation with 31% Natural Sunscreen Minerals - BUNDLED! Get 3 of each of our 4 bee-utiful shades that match skin tone perfectly and provide long lasting protection. \n\nBundle comes with 3 each of our 4 tints - (3) Valerie, (3) Tiffany, (3) Katie, & (3) Vivian AND Custom Engraved Wood Display (pictured).\n\nOur Mineral Makeup is literally the SAFEST you can find, made with zero parabens, talc, synthetic chemicals, preservatives, or artificial fragrance. Packaged in easy-to-apply 1/2 OZ Twist Up Tubes -or- Eco-Friendly 2 OZ Paper Push Up Tubes. \n\nIngredients: 31% Zinc Oxide (Non-Nano), *Cucurbita maxima (Pumpkin Seed) Oil, *Helianthus annuus (Sunflower) oil, *Carthamus tinctorius (Safflower) Oil, *Cera alba (Beeswax), Vitamin E (non-GMO), Iron Oxides (natural color)\n*Organic Ingredient",
  tags: [],
  msrpDollars: 299.31,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:10.234Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
